// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const NginxIcon = createSvgIcon(
  <svg viewBox="-35.5 26 32 32">
    <path
      fill="#009438"
      d="M-33.44 42.02V34.4a.7.7 0 0 1 .38-.65l13.18-7.61q.36-.24.74-.03l13.23 7.63a.7.7 0 0 1 .35.65v15.25a.7.7 0 0 1-.35.65l-11.37 6.57-1.8 1.04a.8.8 0 0 1-.8 0l-13.2-7.61q-.36-.2-.36-.62z"
    />
    <path
      fill="#fefefe"
      d="M-24.12 39.18v8.9c0 1-.8 1.9-1.86 1.87a1.74 1.74 0 0 1-1.74-1.75V35.84c0-.83.5-1.42 1.15-1.7s1.3-.2 1.96 0c.62.19 1.1.57 1.5 1.05l7.87 9.44.12.15v-9c0-.95.65-1.7 1.57-1.78a1.8 1.8 0 0 1 2.04 1.54v12.6q-.01 1.05-.92 1.54c-.44.24-.91.3-1.42.27a3.2 3.2 0 0 1-1.95-.83c-.3-.27-.5-.6-.77-.9l-7.49-8.96q0-.04-.06-.1z"
    />
  </svg>,
  "Nginx",
);
export default NginxIcon;
